import { TextInput as MantineTextInput, TextInputProps } from '@mantine/core';

const cleanInvisibleCharacters = (value: string) => {
  if (!value) return '';
  return value.replace(/[\u200B-\u200F\u202A-\u202E\u2066-\u2069]/g, '');
};

const TextInput = (props: TextInputProps) => {
  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const cleanedValue = cleanInvisibleCharacters(event.target.value);
    event.target.value = cleanedValue;
    props.onChange?.(event);
  };

  return <MantineTextInput {...props} onChange={handleChange} />;
};

export default TextInput;
